import { createContext, useEffect, useRef, useState } from 'react';
import { createTour, updateTourForDesktop, updateTourForMobile } from './tour';
import { startTour, cancelTour } from './tour-utils';

export const TourContext = createContext();

export function TourProvider({ children }) {
  const [tour] = useState(createTour());

  useEffect(() => {
    if (!tour) return;

    const params = new URLSearchParams(window.location.search);
    if (!params.has('guided_tour_v2')) {
      return;
    }

    if (!tour.isActive()) {
      startTour(tour);
    }

    return () => {
      if (tour.isActive()) {
        cancelTour(tour);
      }
    };
  }, [tour]);

  const drawerVisibilityRef = useRef(false);
  useEffect(() => {
    const tourDrawerButton = document.querySelector('.tour-drawer');
    const body = document.querySelector('body');

    const resizeObserver = new ResizeObserver(() => {
      const drawerVisibility = tourDrawerButton
        ? tourDrawerButton.checkVisibility()
        : false;

      if (drawerVisibilityRef.current === drawerVisibility) {
        return;
      }

      drawerVisibilityRef.current = drawerVisibility;

      if (!drawerVisibility) {
        updateTourForDesktop(tour);
      } else {
        updateTourForMobile(tour);
      }
    });

    resizeObserver.observe(body);

    return () => {
      resizeObserver.unobserve(body);
    };
  }, [tour]);

  return (
    <TourContext.Provider value={{ tour }}>{children}</TourContext.Provider>
  );
}
